import {
    getFormattedDate,
    getNightsCount,
    getSearchFilters,
    hasFilledDates
} from './';

function triggerSearchSubmitEdapEvent(tracking, edap, search, destination, dates, guests) {
    const {
        searchSubmitEventName,
        datedSearchSubmitEventName
    } = edap.options;

    const {
        startDate,
        endDate
    } = dates.latestValues;

    const {
        adultsCount,
        childrenCount,
        petIncluded
    } = guests.latestValues;

    const isDatedSearch = hasFilledDates(startDate, endDate);

    function getEventName() {
        return isDatedSearch ? datedSearchSubmitEventName : searchSubmitEventName;
    }

    function getEventData() {
        let nightsCount;

        let eventData = {
            numadults: adultsCount,
            numchildren: childrenCount,
            withpets: petIncluded
        };

        if (isDatedSearch) {
            nightsCount = getNightsCount(startDate, endDate);

            eventData = {
                ...eventData,
                startdate: startDate,
                enddate: endDate,
                lengthofstay: nightsCount
            };
        }

        function getEventRefinements() {
            const sleepsCount = adultsCount + childrenCount;

            const adultsRefinement = `adults_${adultsCount}`;
            const childrenRefinement = `children_${childrenCount}`;
            const sleepsRefinement = `sleeps_${sleepsCount}`;
            const petsRefinement = `pets_${petIncluded}`;

            let eventRefinements = [
                adultsRefinement,
                childrenRefinement,
                sleepsRefinement,
                petsRefinement
            ];

            if (isDatedSearch) {
                const currentDate = getFormattedDate(new Date());
                const windowCount = getNightsCount(currentDate, startDate);

                const nightsRefinement = `nights_${nightsCount}`;
                const windowRefinement = `window_${windowCount}`;

                eventRefinements = [
                    ...eventRefinements,
                    nightsRefinement,
                    windowRefinement
                ];
            }

            const searchFilters = getSearchFilters(search, destination);

            eventRefinements = [
                ...eventRefinements,
                ...searchFilters
            ];

            eventRefinements = eventRefinements.join(',');

            return eventRefinements;
        }

        const eventRefinements = getEventRefinements();

        eventData = {
            ...eventData,
            eventrefinements: eventRefinements
        };

        return eventData;
    }

    const eventName = getEventName();
    const eventData = getEventData();

    tracking.trigger(eventName, eventData);
}

function triggerSearchQuerySubmittedEdapEvent(tracking, edap) {
    const {
        searchQuerySubmittedEventName: eventName
    } = edap.options;

    tracking.trigger(eventName);
}

export {
    triggerSearchQuerySubmittedEdapEvent,
    triggerSearchSubmitEdapEvent
};
